import React, { useState } from 'react';
import axios from 'axios';
import { baseAPI } from '../../config';
import { toast } from 'react-toastify';
import ModalSimple from '../ModalSimple';
import Select from 'react-select';
import { TrashIcon } from '@heroicons/react/24/outline';

const DeleteOperator = ({ 
  operatorToDelete,
  company,
  operators,
  fetchOperators
}) => {
  const {operators_handle_all} = company;
  
  const [isOpen, setIsOpen] = useState(false);
  const [selectedReassignOperator, setSelectedReassignOperator] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteOperator = async () => {
    setIsDeleting(true);
    if (window.confirm('¿Estás seguro de que quieres eliminar este usuario?')) {
      try {
        const token = localStorage.getItem('token');
        await axios.delete(`${baseAPI}/users/${operatorToDelete._id}`, {
          data: {
            reassing_to_id: selectedReassignOperator?.value || null
          },
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        toast.success('Usuario eliminado correctamente');
        fetchOperators();
      } catch (error) {
        toast.error('Error al eliminar el usuario');
      }
    }
    setIsDeleting(false);
    handleClose();
  };

  const handleDeleteUser = () => {
    if (operators_handle_all) {
      deleteOperator();
    } else {
      setIsOpen(true);
    }
  };

  const handleClose = () => {
    setSelectedReassignOperator(null);
    setIsOpen(false);
  };

  return (
    <div>  
      <button
        onClick={() => handleDeleteUser()}
        className="text-red-600 hover:text-red-900"
        title="Eliminar"
      >
        <TrashIcon className="h-4 w-4" />
      </button>
      
    
    <ModalSimple
      id="delete-operator-modal"
      title="Eliminar Operador"
      show={isOpen}
      onClose={handleClose}
      size="lg"
    >
      <div className="mb-6 text-left">
        <p className="text-sm text-gray-600 mb-4">
          El usuario <strong>{operatorToDelete.username} {operatorToDelete.userlastname}</strong> puede tener expedientes asignados. 
          ¿Qué quieres hacer con estos expedientes?
        </p>
        
        <div className="space-y-4 pb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Reasignar expedientes a otro operador:
            </label>
            <Select
              value={selectedReassignOperator}
              onChange={setSelectedReassignOperator}
              options={operators
                .filter(operator => operator._id !== operatorToDelete._id)
                .map(operator => ({
                  value: operator._id,
                  label: `${operator.username} ${operator.userlastname}`
                }))}
              placeholder="Selecciona un operador..."
              isClearable
              isSearchable
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
        <button
          type="button"
          onClick={handleClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50"
        >
          Cancelar
        </button>
        <button
          type="button"
          onClick={deleteOperator}
          disabled={isDeleting}
          className="px-4 py-2 text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
        >
          Eliminar sin reasignar
        </button>
        <button
          type="button"
          onClick={deleteOperator}
          disabled={!selectedReassignOperator || isDeleting}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isDeleting ? 'Procesando...' : 'Reasignar y Eliminar'}
        </button>
      </div>
    </ModalSimple>
    </div>
  );
};

export default DeleteOperator; 